module.exports = __webpack_public_path__ + "img/bilal-bentoumi.ab0d7f93.jpg";